var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSwitcherRight = function SvgSwitcherRight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 11,
    "data-width-24": 16,
    viewBox: "0 0 15.5 15.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.462 15.425a.7.7 0 0 0 .287.056.74.74 0 0 0 .53-.22l7-7a.75.75 0 0 0 0-1.06l-7-7a.75.75 0 0 0-1.06 1.06l6.47 6.47-6.47 6.47a.75.75 0 0 0 .243 1.224m7 0a.7.7 0 0 0 .287.056.74.74 0 0 0 .53-.22l7-7a.75.75 0 0 0 0-1.06l-7-7a.75.75 0 0 0-1.06 1.06l6.47 6.47-6.47 6.47a.75.75 0 0 0 .243 1.224",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSwitcherRight);
export default ForwardRef;